import { useTranslation } from 'react-i18next';

export function AdvisorMessageThreadOnboardingReminder() {
  const { t: tUI } = useTranslation('UI');

  return (
    <p className="text-palette-600 mt-2 mb-4">
      {tUI('conversation-thread-message-advisor-onboarding-reminder-confirmation')}
    </p>
  );
}
